/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Collapse, List, Divider, Progress, Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Loader from "../../components/Common/Loader";
import FormControl from "../../components/Common/FormControl";
import FormLabel from "../../components/Common/FormLabel";
// import placeholderFrontImage from "../../styles/Assets/defaultImg.png";
import ExercisePlaceholder from "../../styles/Assets/exercise_placeholder_100_100.png";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import {
  clearExerciseUpdateResponse,
  postExerciseDetailsOnSessionId,
} from "../../redux/Slices/chatBotSlice";
import { CONSTANTS } from "../../utils/Constant/Constant";
import ToastNotification from "../../components/Common/ToastNotification";
import WorkoutPlaceholder from "../../styles/Assets/workout_placeholder.jpg";
import WorkoutSessionPlaceholder from "../../styles/Assets/workout_session_placeholder.jpeg";
import appInsights from "../../AppInsights";

const { Panel } = Collapse;

const AIAssistanceWorkoutPlanModal = ({
  showModal,
  setShowModal,
  workoutPlanList,
  modalLoading,
  onSessionsSelected,
  selectedSessions,
  setSelectedSessions,
  resData,
  onWorkoutPlanUpdated
}) => {
  const dispatch = useDispatch();
  const { exerciseUpdateResponse, error, loading } = useSelector(
    (state) => state.chatBot,
  );
  const { trans } = useCustomTranslation();
  const [activeKey, setActiveKey] = useState(null);
  const [toastConfig, setToastConfig] = useState(null);

  const formatProgress = (percent) => {
    return <div className="workout-plan-progress-bar">{percent}%</div>;
  };

  const handlePanelChange = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const transformWorkoutResponseToApiPayload = (resData) => {
    console.log("test_resData", resData);

    return {
      updated_session: (resData.updated_session || []).map((session) => ({
        session_id: session.session_id,
        clientWorkoutPlanId: session.clientWorkoutPlanId,
        session_name: session.updated_session?.session_name,
        // updated_session: {
        //   session_id: session.updated_session?.session_id,
        //   session_name: session.updated_session?.session_name,
        exercises: (session.updated_session?.exercises || []).map(
          (exercise) => ({
            clientWorkoutPlanExerciseId: exercise.clientWorkoutPlanExerciseId,
            clientWorkoutPlanSessionId: exercise.clientWorkoutPlanSessionId,
            exercise: exercise.exercise,
            sets: exercise.sets,
            reps: exercise.reps,
            sec: exercise.sec,
            note: exercise.note,
            exerciseImage: {
              coachId: exercise.exerciseImage?.coachId ?? null,
              id: exercise.exerciseImage?.id ?? null,
              mediaId: exercise.exerciseImage?.mediaId ?? null,
              title: exercise.exerciseImage?.title ?? null,
              description: exercise.exerciseImage?.description ?? null,
              sourceType: exercise.exerciseImage?.sourceType ?? null,
              blobUrl: exercise.exerciseImage?.blobUrl ?? null,
              language: exercise.exerciseImage?.language ?? null,
              fileName: exercise.exerciseImage?.fileName ?? null,
              mediaType: exercise.exerciseImage?.mediaType ?? null,
              fileType: exercise.exerciseImage?.fileType ?? null,
              createdOn: exercise.exerciseImage?.createdOn ?? null,
            },
            exerciseId: exercise.exerciseId,
            instructions: exercise.instructions,
          }),
        ),
        // },
      })),
    };
  };

  const handleUpdateWorkoutPlan = () => {
    const apiPayload = transformWorkoutResponseToApiPayload(resData);
    // console.log("test_apiPayload", apiPayload);
    console.log("test_apiPayload", apiPayload);
    dispatch(postExerciseDetailsOnSessionId(apiPayload));
    // setShowModal(false);
  };

  useEffect(() => {
    if (exerciseUpdateResponse) {
       // AppInsights Success Event
      appInsights.trackEvent({
        name: "AI_Exercise_Update_Success",
        properties: {
          response: exerciseUpdateResponse,
        },
      });
      setShowModal(false);

      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        heading: trans("Common.success"),
        message: exerciseUpdateResponse || "Workout plan updated successfully!",
      });
      setTimeout(() => {
        onWorkoutPlanUpdated?.();
        setToastConfig(null);
        dispatch(clearExerciseUpdateResponse());
        setShowModal(false);
      }, CONSTANTS.TOAST_DURATION_SHORT);
      // close modal and clear slice state
    } else if (error) {
      setShowModal(false);
      // AppInsights Error Event
      appInsights.trackException({
        exception: new Error(error),
        properties: {
          action: "AI_Exercise_Update_Failed",
        },
      });

      setToastConfig({
        type: CONSTANTS.TOAST_ERROR,
        heading: trans("Common.error"),
        message: error || "Something went wrong!",
      });
      setTimeout(() => {
        setToastConfig(null);
      }, CONSTANTS.TOAST_DURATION_SHORT);
    }
  }, [exerciseUpdateResponse]);

  // Handle session checkbox change
  const handleSessionCheckbox = (sessionId, sessionName, checked) => {
    if (checked) {
      // Add session object to state
      setSelectedSessions((prev) => [
        ...prev,
        { id: sessionId, name: sessionName },
      ]);
    } else {
      // Remove session object from state
      setSelectedSessions((prev) =>
        prev.filter((session) => session.id !== sessionId),
      );
    }
  };

  // 🔹 Pass selected sessions to parent whenever they change
  React.useEffect(() => {
    if (onSessionsSelected) {
      onSessionsSelected(selectedSessions);
    }
  }, [selectedSessions, onSessionsSelected]);

  if (!showModal && !toastConfig) return null;

  // Transform workoutPlanList into grouped format if it's from chatbot
  const groupedWorkouts = Array.isArray(workoutPlanList)
    ? workoutPlanList.reduce((acc, workout) => {
        const planId = workout.clientWorkoutPlanId;
        if (!acc[planId]) {
          acc[planId] = {
            workoutPlanId: planId,
            name: workout.name,
            created_on: workout.created_on,
            sessions: [],
          };
        }
        acc[planId].sessions.push({
          session_id: workout.session_id,
          session_name: workout.session_name,
          workout_type: workout.workout_type,
          total_sets: workout.total_sets,
          exercises: workout.exercises || [],
        });
        return acc;
      }, {})
    : {};

  const workoutPlans = Object.values(groupedWorkouts);

  return (
    <>
    {showModal && (
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target.className === "modal-overlay") 
            setShowModal(false);
          
        }}
      >
        <div
          className={`modal-content ${
            modalLoading ? "modal-content-loading" : ""
          }`}
        >
          <div className="modal-header">
            <h4>Workout Plan Details</h4>
            <button
              className="modal-close"
              onClick={() => setShowModal(false)}
              disabled={modalLoading}
            >
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="ai-modal-body">
            {modalLoading ? (
              <Loader />
            ) : (
              <>
                {workoutPlans.length > 0 ? (
                  <Collapse
                    collapsible={false}
                    activeKey={activeKey}
                    onChange={handlePanelChange}
                    accordion
                  >
                    {workoutPlans.map((plan) => (
                      <Panel
                        className="Panel-workout-accordion"
                        key={plan.workoutPlanId}
                        header={
                          <div className="collapse-header-workoutplan d-flex align-items-center">
                            <img
                              src={WorkoutPlaceholder}
                              alt="Workout Plan"
                              className="excer-image mr-2"
                            />

                            <span className="workout-plan-plan">
                              {plan.name}
                            </span>

                            <div className="session-count ml-auto">
                              <span>
                                {plan.sessions.length} Session
                                {plan.sessions.length !== 1 ? "s" : ""}
                              </span>
                            </div>

                            <DownOutlined className="down-arrow-accordion ml-2" />
                          </div>
                        }
                        showArrow={false}
                      >
                        <Row>
                          {/* 🔹 Sessions Label with Checkboxes */}
                          <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                            <FormLabel
                              className="Label-text-workout-plan"
                              label={trans("ClientWorkout.sessions")}
                            />
                            {/* You can add a "Select All" checkbox here if needed */}
                          </div>

                          <Collapse accordion>
                            {plan.sessions.map((session) => (
                              <Panel
                                header={
                                  <div className="d-flex alignToRight align-items-center">
                                    {/* Checkbox for session selection */}
                                    <Checkbox
                                      checked={selectedSessions.some(
                                        (s) => s.id === session.session_id,
                                      )}
                                      onChange={(e) =>
                                        handleSessionCheckbox(
                                          session.session_id,
                                          session.session_name,
                                          e.target.checked,
                                        )
                                      }
                                      onClick={(e) => e.stopPropagation()} // Prevent panel toggle
                                      style={{ marginRight: "12px" }}
                                    />
                                    <img
                                      src={WorkoutSessionPlaceholder}
                                      alt="Workout Session"
                                      className="excer-image"
                                    />
                                    <div className="Session-name-bold">
                                      {session.session_name}
                                    </div>
                                    <div className="sets-bold">
                                      {session.total_sets} sets (
                                      {session.exercises?.length || 0}{" "}
                                      exercises)
                                    </div>
                                  </div>
                                }
                                key={session.session_id}
                              >
                                <Row>
                                  <List
                                    bordered
                                    dataSource={session.exercises
                                      ?.slice()
                                      .sort(
                                        (a, b) =>
                                          (a.raw?.indexOrder || 0) -
                                          (b.raw?.indexOrder || 0),
                                      )}
                                    renderItem={(item, index) => (
                                      <div className="p-2" key={index}>
                                        <div className="d-flex">
                                          <div>
                                            <List.Item>
                                              <img
                                                src={
                                                  item?.exerciseImage
                                                    ?.blobUrl ||
                                                  ExercisePlaceholder
                                                }
                                                alt={item.exercise}
                                                className="excer-image"
                                              />
                                            </List.Item>
                                          </div>
                                          <div>
                                            <Row className="allign-excer-name">
                                              <List.Item.Meta
                                                className="excer-name"
                                                title={item.exercise}
                                              />
                                            </Row>
                                            <Row>
                                              <div className="d-flex">
                                                <div className="exer-sets-width">
                                                  <FormControl
                                                    className="rounded-3"
                                                    isDisabled={true}
                                                    value={item.sets}
                                                    suffix={trans(
                                                      "ClientWorkout.sets",
                                                    )}
                                                  />
                                                </div>

                                                <div className="exer-sets-width allign-planned-exer">
                                                  <FormControl
                                                    className="rounded-3"
                                                    isDisabled={true}
                                                    isDropdown={true}
                                                    value={item.reps}
                                                    suffix={trans(
                                                      "ClientWorkout.reps",
                                                    )}
                                                  />
                                                </div>
                                                <div className="exer-sets-width exersets-allign">
                                                  <FormControl
                                                    className="rounded-3"
                                                    isDisabled={true}
                                                    value={item.sec}
                                                    suffix={trans(
                                                      "ClientWorkout.secs",
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                            </Row>
                                            <Row>
                                              <FormLabel
                                                className="mx-2 mt-1"
                                                label={"Notes"}
                                              />
                                              <div className="mx-2 exer-notes-width">
                                                <FormControl
                                                  className="rounded-3"
                                                  isDisabled={true}
                                                  value={item.note}
                                                  Rows={4}
                                                />
                                              </div>
                                            </Row>
                                            {item.raw?.noOfSetsCompleted !==
                                              null && (
                                              <Row>
                                                <div className="mx-2 mt-2">
                                                  <Progress
                                                    format={formatProgress}
                                                    strokeColor={{
                                                      "0%": "#383D8D",
                                                      "100%": "#A42066",
                                                    }}
                                                    percent={Math.round(
                                                      (item?.raw
                                                        ?.noOfSetsCompleted /
                                                        parseInt(item.sets)) *
                                                        100,
                                                    )}
                                                    className="workout-plan client-progress-width"
                                                  />
                                                </div>
                                              </Row>
                                            )}
                                          </div>
                                        </div>

                                        {index <
                                          session.exercises?.length - 1 && (
                                          <Divider className="divider-workout-plan" />
                                        )}
                                      </div>
                                    )}
                                  />
                                </Row>
                              </Panel>
                            ))}
                          </Collapse>
                        </Row>
                      </Panel>
                    ))}
                  </Collapse>
                ) : (
                  <div className="middle-text-noplan">
                    {trans("ClientWorkout.noWorkoutPlan")}
                  </div>
                )}
              </>
            )}
          </div>

          <div className="modal-footer">
            {/* 🔹 Display selected session names */}
            {selectedSessions.length > 0 && (
              <div
                style={{ marginRight: "auto", fontSize: "14px", color: "#666" }}
              >
                Selected: {selectedSessions.map((s) => s.name).join(", ")}
              </div>
            )}

            <Button
              variant="outline-primary"
              onClick={() => setShowModal(false)}
              size="sm"
              className="cancel-button w-25 p-0"
            >
              {trans("Common.close")}
            </Button>
            {Array.isArray(resData?.updated_session) && (
              <Button
                variant="primary"
                onClick={handleUpdateWorkoutPlan}
                size="sm"
                className="saveButton w-25 ml-2 p-0"
              >
                {loading ? "Updating..." : trans("Common.update")}
              </Button>
            )}
          </div>
        </div>
      </div>
      )}
      {toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
        />
      )}
    </>
  );
};

export default AIAssistanceWorkoutPlanModal;
